import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiArrowDownSLine } from "react-icons/ri";
import {
  getRequest,
  putRequest,
  putWithFormData,
} from "../../helpers/api.helper";
import { StepPropsType } from "../../types";
import { useLanguage } from "../../context/LanguageContext";
import { totalPropertyValueOptions } from "../../utils/constants";

type City = {
  id?: number;
  city?: string;
};

const Step6 = ({
  bureauId,
  setCurrentStep,
  currentStep,
  steps,
  profileId,
  setCompletedSteps,
}: StepPropsType) => {
  const { t } = useLanguage();

  const [modalData, setModalData] = useState<any>(null);
  const [modalData2, setModalData2] = useState<any>(null);
  const [modalData3, setModalData3] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [searchTerm3, setSearchTerm3] = useState("");

  const [city, setCity] = useState<City[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>({});
  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    Own_House_Location: [], // Default for own house location (can be multiple)
  });

  const [selectedOptions3, setSelectedOptions3] = useState<any>({
    Plot_Location: [], // Default for languages known (can be multiple)
  });
  const dropdownOptions: any = {
    House_Type: [
      { value: "No House", label: "No House" },
      { value: "groundFloor", label: "Ground Floor" },
      { value: "g+1", label: "G+1" },
      { value: "g+2", label: "G+2" },
      { value: "g+3", label: "G+3" },
      { value: "g+4", label: "G+4" },
      { value: "g+5", label: "G+5" },
      { value: "g+6", label: "G+6" },
      { value: "g+7", label: "G+7" },
      { value: "g+8", label: "G+8" },
      { value: "g+9", label: "G+9" },
      { value: "g+10", label: "G+10" },
    ],
    No_Of_Houses: [
      { value: "0", label: "0" },
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
      { value: "4", label: "4" },
      { value: "5", label: "5" },
      { value: "6", label: "6" },
      { value: "7", label: "7" },
      { value: "8", label: "8" },
      { value: "9", label: "9" },
      { value: "10", label: "10" },
    ],
    Own_House_sq_Yard: [
      ...Array.from({ length: 1000 - 70 + 1 }, (_, index) => 70 + index).map(
        (sqFeet) => ({
          value: sqFeet,
          label: `${sqFeet} Yards`,
        }),
      ),
    ],
    Own_House_Total_Value: totalPropertyValueOptions,
    Commercial_Shops: [
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
      { value: "4", label: "4" },
      { value: "5", label: "5" },
      { value: "6", label: "6" },
      { value: "7", label: "7" },
      { value: "8", label: "8" },
      { value: "9", label: "9" },
      { value: "10", label: "10" },
    ],
    Shops_Sq_Yards: [
      ...Array.from({ length: 1000 - 70 + 1 }, (_, index) => 70 + index).map(
        (sqFeet) => ({
          value: sqFeet,
          label: `${sqFeet} Yards`,
        }),
      ),
    ],
    Monthly_Rent: [
      ...Array.from({ length: 200 }, (_, index) => 50000 + index * 50000).map(
        (value) => ({
          value: value,
          label: `₹${value.toLocaleString("en-IN")}`,
        }),
      ),
    ],
    Open_Plots: [
      ...Array.from({ length: 20 }, (_, i) => i + 1).map((value) => ({
        value: value,
        label: value.toString(),
      })),
    ],
    Open_Plots_Sq_Yards: [
      ...Array.from({ length: 1000 - 70 + 1 }, (_, index) => 70 + index).map(
        (sqFeet) => ({
          value: sqFeet,
          label: `${sqFeet} Yards`,
        }),
      ),
    ],
    Open_Plots_total_value: totalPropertyValueOptions,
  };
  const dropdownOptions2: any = {
    Own_House_Location: city.map((job_location) => ({
      value: job_location.city,
      label: job_location.city,
    })),
  };

  const dropdownOptions3: any = {
    Plot_Location: city.map((plot_location) => ({
      value: plot_location.city,
      label: plot_location.city,
    })),
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest("/common/city");
        if (Array.isArray(response)) {
          setCity(response);
          return;
        }
        if (response?.success && Array.isArray(response.data)) {
          setCity(response.data);
        }
      } catch (error) {
        console.error("Error fetching city data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!profileId) return;

    if (!city.length) return;

    const fetchStep6Data = async () => {
      try {
        const res = await getRequest(`/bureau/profile/${profileId.martialId}`);
        if (!res?.data) return;
        const data = res.data;

        setSelectedOptions((prev: any) => ({
          ...prev,

          House_Type: data.houseType
            ? dropdownOptions.House_Type.find(
                (opt: any) => opt.value === data.houseType,
              )
            : prev.House_Type,

          No_Of_Houses: data.numberOfHouses
            ? dropdownOptions.No_Of_Houses.find(
                (opt: any) => opt.value === String(data.numberOfHouses),
              )
            : prev.No_Of_Houses,

          Own_House_sq_Yard: data.houseSqFeet
            ? {
                value: data.houseSqFeet,
                label: `${data.houseSqFeet} Yards`,
              }
            : prev.Own_House_sq_Yard,

          Own_House_Total_Value: data.houseValue
            ? {
                value: data.houseValue,
                label: data.houseValue,
              }
            : prev.Own_House_Total_Value,

          Monthly_Rent: data.monthlyRent
            ? {
                value: data.monthlyRent,
                label: `₹${Number(data.monthlyRent).toLocaleString("en-IN")}`,
              }
            : prev.Monthly_Rent,

          Commercial_Shops: data.commercialshops
            ? dropdownOptions.Commercial_Shops.find(
                (opt: any) => opt.value === String(data.commercialshops),
              )
            : prev.Commercial_Shops,

          Shops_Sq_Yards: data.shopssqyards
            ? {
                value: data.shopssqyards,
                label: `${data.shopssqyards} Yards`,
              }
            : prev.Shops_Sq_Yards,

          Open_Plots: data.openPlots
            ? {
                value: data.openPlots,
                label: String(data.openPlots),
              }
            : prev.Open_Plots,

          Open_Plots_Sq_Yards: data.openPlotsSqFeet
            ? {
                value: data.openPlotsSqFeet,
                label: `${data.openPlotsSqFeet} Yards`,
              }
            : prev.Open_Plots_Sq_Yards,

          Open_Plots_total_value: data.openPlotsValue
            ? {
                value: data.openPlotsValue,
                label: data.openPlotsValue,
              }
            : prev.Open_Plots_total_value,
        }));

        setSelectedOptions2((prev: any) => ({
          ...prev,
          Own_House_Location: Array.isArray(data.houseLocation)
            ? data.houseLocation
            : [],
        }));
        setSelectedOptions3((prev: any) => ({
          ...prev,
          Plot_Location: Array.isArray(data.openPlotsLocation)
            ? data.openPlotsLocation
            : [],
        }));
      } catch (err) {
        console.error("Failed to load Step6 data", err);
      }
    };

    if (bureauId) fetchStep6Data();
  }, [profileId, city.length]);

  const openModal = (key: any) => {
    setModalData({ key, options: dropdownOptions[key] });
  };

  const openModal2 = (key: any) => {
    setModalData2({ key });
  };

  const openModal3 = (key: any) => {
    setModalData3({ key });
  };

  const closeModal = () => {
    setModalData(null);
    setSearchTerm("");
  };

  const closeModal2 = () => {
    setModalData2(null);
    setSearchTerm2("");
  };
  const closeModal3 = () => {
    setModalData3(null);
    setSearchTerm3("");
  };

  const handleSelect = (selectedOption: any) => {
    setSelectedOptions({ ...selectedOptions, [modalData.key]: selectedOption });
    closeModal();
  };
  const handleSelect2 = (selectedOption2: any) => {
    setSelectedOptions2({
      ...selectedOptions2,
      [modalData2.key]: selectedOption2,
    });
    closeModal2();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const formattedOptions = {
      houseType: selectedOptions.House_Type?.value || "",
      houseSqFeet: selectedOptions.Own_House_sq_Yard?.value || "",
      houseValue: selectedOptions.Own_House_Total_Value?.value || "",
      monthlyRent: selectedOptions.Monthly_Rent?.value || "",
      openPlots: selectedOptions.Open_Plots?.value || "",
      openPlotsSqFeet: selectedOptions.Open_Plots_Sq_Yards?.value || "",
      openPlotsValue: selectedOptions.Open_Plots_total_value?.value || "",
      numberOfHouses: selectedOptions.No_Of_Houses?.value || "",
      commercialshops: selectedOptions.Commercial_Shops?.value || "",
      shopssqyards: selectedOptions.Shops_Sq_Yards?.value || "",
    };

    // Send the form data with updated family property fields
    const formDataToSend = {
      ...formattedOptions,
      houseLocation: selectedOptions2.Own_House_Location,

      openPlotsLocation: selectedOptions3.Plot_Location,
      // Including step flags to indicate progress
      step1: 1,
      step2: 1,
      step3: 1,
      step4: 1,
      step5: 1,
      step6: 1, // You can modify this flag to indicate step 5 completion
    };

    try {
      const response = await putRequest(
        `/bureau/profile/${profileId?.userId}`,
        formDataToSend,
      );

      if (response.success) {
        setCompletedSteps?.((prev) =>
          prev.includes(currentStep) ? prev : [...prev, currentStep],
        );
        if (currentStep < steps.length) {
          setCurrentStep(currentStep + 1);
        }
      } else {
        alert("Failed to update details.");
      }
    } catch (error) {
      console.error("Error updating details:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);

  const handleCheckboxChange2 = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions2 = checked
      ? [...selectedOptions2.Own_House_Location, option.value]
      : selectedOptions2.Own_House_Location.filter(
          (lang: any) => lang !== option.value,
        );

    setSelectedOptions2({
      ...selectedOptions2,
      Own_House_Location: updatedSelectedOptions2,
    });
  };

  const handleCheckboxChange3 = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions3 = checked
      ? [...selectedOptions3.Plot_Location, option.value]
      : selectedOptions3.Plot_Location.filter(
          (skill: any) => skill !== option.value,
        );

    setSelectedOptions3({
      ...selectedOptions3,
      Plot_Location: updatedSelectedOptions3,
    });
  };

  const modalOptions2 = modalData2?.key ? dropdownOptions2[modalData2.key] : [];

  const modalOptions3 = modalData3?.key ? dropdownOptions3[modalData3.key] : [];

  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg">
      {/* Form */}
      <div className="space-y-6 py-4 px-3">
        {Object.keys(dropdownOptions).map((key) => (
          <>
            <div className="mb-[-20px]">
              <label className="block text-red-500 font-medium mb-2">
                {t(key.replace(/_/g, " "))}
              </label>
            </div>

            <div
              key={key}
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal(key)}
            >
              <div className="flex items-center justify-between rounded-lg">
                <span className="text-gray-500 text-md ">
                  {selectedOptions[key]?.label || `Select ${key}`}
                </span>
                <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
              </div>
            </div>
          </>
        ))}
        {/* Second objects 2 */}
        {Object.keys(dropdownOptions2).map((key) => (
          <div key={key} className="mb-[-20px] rounded-lg">
            <label className="block text-red-500 font-medium mb-2 capitalize">
              {t(key.replace(/_/g, " "))}
            </label>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal2(key)}
            >
              <div className="flex items-center justify-between rounded">
                <span className="text-gray-500 text-md ">
                  {selectedOptions2[key]?.length
                    ? dropdownOptions2[key]
                        .filter((opt: any) =>
                          selectedOptions2[key].includes(opt.value),
                        )
                        .map((lang: any) => lang.label)
                        .join(", ")
                    : `Select ${key}`}
                </span>
                <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
              </div>
            </div>
          </div>
        ))}

        {Object.keys(dropdownOptions3).map((key) => (
          <div key={key} className="mb-[-20px] rounded-lg">
            <label className="block text-red-500 font-medium mb-2 capitalize">
              {t(key.replace(/_/g, " "))}
            </label>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal3(key)}
            >
              <div className="flex items-center justify-between rounded">
                <span className="text-gray-500 text-md ">
                  {selectedOptions3[key]?.length
                    ? dropdownOptions3[key]
                        .filter((opt: any) =>
                          selectedOptions3[key].includes(opt.value),
                        )
                        .map((skill: any) => skill.label)
                        .join(", ")
                    : `Select ${key}`}
                </span>
                <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
              </div>
            </div>
          </div>
        ))}

        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-6">
          {/* <button
            onClick={() => {
              setCurrentStep(Math.max(1, currentStep - 1));
            }}
            className="flex-1 px-6 py-3.5 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            Previous
          </button> */}
          <button
            onClick={handleSubmit}
            className="flex-1 px-6 py-3.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all shadow-lg"
          >
            {currentStep === steps.length ? t("Submit") : t("Next Step")}
          </button>
        </div>
      </div>
      {modalData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData.key)}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData.key}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData.options
                .filter((option: any) =>
                  option.label.toLowerCase().includes(searchTerm.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <div key={index}>
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 transition"
                      onClick={() => handleSelect(option)}
                    >
                      {option.label}
                    </button>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </div>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
      {modalData3 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center  items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData3.key)}
            </h2>

            {/* "Select All" Checkbox */}
            {/* <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox"
                  type="checkbox"
                  checked={
                    selectedOptions.languagesKnown.length ===
                    dropdownOptions.languagesKnown.length
                  }
                  onChange={handleSelectAllChange}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Select All</label>
              </div> */}

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData3.key}`}
              value={searchTerm3}
              onChange={(e) => setSearchTerm3(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalOptions3
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm3.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <>
                    <div key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedOptions3.Plot_Location.includes(
                          option.value,
                        )}
                        onChange={(e) => handleCheckboxChange3(e, option)}
                        className="form-checkbox h-4 w-4 text-red-600"
                      />
                      <label className="block text-gray-700">
                        {option.label}
                      </label>
                    </div>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal3}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
      {modalData2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center  items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData2.key)}
            </h2>
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData2.key}`}
              value={searchTerm2}
              onChange={(e) => setSearchTerm2(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalOptions2
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm2.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <>
                    <div key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedOptions2.Own_House_Location.includes(
                          option.value,
                        )}
                        onChange={(e) => handleCheckboxChange2(e, option)}
                        className="form-checkbox h-4 w-4 text-red-600"
                      />
                      <label className="block text-gray-700">
                        {option.label}
                      </label>
                    </div>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal2}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step6;
